import { API } from './resources'

export default {
  get: (groupName, nextPageToken) => {
    return API.get('/features', { params: { featureGroupName: groupName, pageSize: 10, pageToken: nextPageToken } })
  }
}
